import React from 'react';
import { ChevronDown, ChevronRight } from "lucide-react";
import AppCard from '../../AppCard';

const CategorySection = ({ 
  title, 
  apps, 
  isExpanded, 
  onToggleExpand, 
  onLaunch,
  onVersionSwitch  // Make sure we receive this prop
}) => {
  return (
    <div className="mb-4 md:mb-6">
      <button
        onClick={onToggleExpand}
        className="w-full flex items-center space-x-2 text-left mb-2 md:mb-4 group"
      >
        {isExpanded ? (
          <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-gray-400 group-hover:text-white" />
        ) : (
          <ChevronRight className="w-4 h-4 md:w-5 md:h-5 text-gray-400 group-hover:text-white" />
        )}
        <h2 className="text-base md:text-xl font-semibold text-white group-hover:text-white">
          {title}
          <span className="ml-2 text-xs md:text-sm text-gray-400">({apps.length})</span>
        </h2>
      </button>
      
      {isExpanded && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {apps.map((app) => (
            <AppCard 
              key={app.id}
              app={app}
              onVersionSwitch={onVersionSwitch}  // Pass it to AppCard
              onLaunch={() => onLaunch(app)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySection;